module.exports = __webpack_public_path__ + "static/media/own-import.a47330a7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/About/08_Foto-Import/own-import.jpg
// module id = 744
// module chunks = 0